angular.module('portal-common', []);